export { default } from './SkyBox'
